import { useEffect, useState } from "react";
import { PublicLayout } from "@/components/PublicLayout";
import api from "@/lib/api";

export default function Policies() {
    const [settings, setSettings] = useState(null);
    const [policies, setPolicies] = useState([]);

    useEffect(() => {
        api.get("/settings").then((r) => setSettings(r.data));
        api.get("/policies").then((r) => setPolicies(r.data));
    }, []);

    return (
        <PublicLayout settings={settings}>
            <section className="max-w-4xl mx-auto px-6 py-16">
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-[hsl(var(--muted-foreground))]">Policies</div>
                <h1 className="font-display text-4xl sm:text-5xl mt-3">How we work.</h1>

                <div className="mt-12 space-y-6">
                    {policies.map((p) => (
                        <div key={p.id} className="card-clay p-6" data-testid={`policy-${p.id}`}>
                            <div className="flex justify-between items-start gap-4">
                                <h3 className="font-display text-2xl">{p.title}</h3>
                                {p.is_paid && (
                                    <div className="font-mono text-xs bg-[hsl(var(--secondary))] px-3 py-1 rounded whitespace-nowrap">
                                        ${p.price}
                                    </div>
                                )}
                            </div>
                            {p.is_paid && (
                                <div className="mt-2 text-xs text-[hsl(var(--muted-foreground))]">Payment coming soon.</div>
                            )}
                            <div className="mt-3 whitespace-pre-wrap text-[hsl(var(--muted-foreground))] leading-relaxed">
                                {p.body}
                            </div>
                        </div>
                    ))}
                    {policies.length === 0 && (
                        <div className="text-[hsl(var(--muted-foreground))]">No policies posted yet.</div>
                    )}
                </div>
            </section>
        </PublicLayout>
    );
}
